import Vue from "vue";

/**
 * Check if given variable is a number.
 * If not a number 0 is returned
 * @param {Number} value
 */
function globalIntCheck(value) {
  return isNaN(value) ? 0 : parseInt(value);
}

/**
 * If integer is not returned for specific type, convert them to int
 *
 * @param {Object} appointment
 */
function intCheck(appointment) {
  // ID Check
  appointment.id = globalIntCheck(appointment.id);

  // app_end_hh check
  appointment["app_end_hh"] = globalIntCheck(appointment["app_end_hh"]);

  // app_end_mm check
  appointment["app_end_mm"] = globalIntCheck(appointment["app_end_mm"]);

  // app_end_tt check
  appointment["app_end_tt"] = globalIntCheck(appointment["app_end_tt"]);

  // app_start_hh check
  appointment["app_start_hh"] = globalIntCheck(appointment["app_start_hh"]);

  // app_start_mm check
  appointment[appointment["app_start_mm"]] = globalIntCheck(
    appointment["app_start_mm"]
  );

  // app_start_tt check
  appointment["app_start_tt"] = globalIntCheck(appointment["app_start_tt"]);

  // app_type check
  appointment["app_type"] = globalIntCheck(appointment["app_type"]);

  // appointmentrepeat_id check
  appointment["appointmentrepeat_id"] = globalIntCheck(
    appointment["appointmentrepeat_id"]
  );

  // client_id check
  appointment["client_id"] = globalIntCheck(appointment["client_id"]);

  // client_type check
  appointment["client_type"] = globalIntCheck(appointment["client_type"]);

  // repeats check
  appointment["repeats"] = globalIntCheck(appointment["repeats"]);

  // is_cancelled check
  appointment["is_cancelled"] = globalIntCheck(appointment["is_cancelled"]);

  // is_deleted check
  appointment["is_deleted"] = globalIntCheck(appointment["is_deleted"]);

  // is_video check
  appointment["is_video"] = globalIntCheck(appointment["is_video"]);

  // otherevent_id check
  appointment["otherevent_id"] = globalIntCheck(appointment["otherevent_id"]);

  // otherevent_type check
  appointment["otherevent_type"] = globalIntCheck(
    appointment["otherevent_type"]
  );

  // provider_id check
  appointment["provider_id"] = globalIntCheck(appointment["provider_id"]);

  // reminder_set_status check
  appointment["reminder_set_status"] = globalIntCheck(
    appointment["reminder_set_status"]
  );

  // type check
  appointment["type"] = globalIntCheck(appointment["type"]);

  // repeat check
  appointment["repeat"] = globalIntCheck(appointment["repeat"]);

  // repeat_by check
  appointment["repeat_by"] = globalIntCheck(appointment["repeat_by"]);

  // repeat_freq check
  appointment["repeat_freq"] = globalIntCheck(appointment["repeat_freq"]);

  return appointment;
}

/**
 * Mutations for appointment details
 */
export const mutations = {
  /**
   * Add details of a particular appointment
   *
   * @param {Object} state
   * @param {Object} appointment
   */
  addDetails(state, appointment) {
    // Convert appointment id to integer id integer is not returned
    appointment = intCheck(appointment);

    // Add appointment if not added
    Vue.set(state.details, appointment.id, appointment);
    if (state.idQueried.indexOf(appointment.id) === -1) {
      state.idQueried.push(parseInt(appointment.id));
    }
  },

  /**
   * Add the id to the already queried appointments
   *
   * @param {Object} state
   * @param {Number} id
   */
  addToQueriedIdAppointmentDetails(state, id) {
    if (state.idQueried.indexOf(id) === -1) {
      state.idQueried.push(parseInt(id));
    }
  },

  /**
   * Edit details of an already exiting appointment
   *
   * @param {Object} state
   * @param {Object} appointment
   */
  editDetails(state, appointment) {
    Vue.set(state.details, appointment.id, appointment);
  },

  /**
   * Delete appointment from details
   *
   * @param {Object} state
   * @param {Number} id
   */
  deleteFromDetails(state, id) {
    delete state.details[id];
  },

  /**
   * Set an appointment as cancelled
   *
   * @param {Object} state
   * @param {Number} id
   */
  cancelFromDetails(state, { id, cancelOrUn }) {
    Vue.set(state.details, "id", {
      ...state.details[id],
      is_cancelled: cancelOrUn === "cancel" ? 1 : 0
    });
  },

  /**
   * Weather delete in progress
   *
   * @param {Object} state
   * @param {Boolean} value
   */
  setDeleted(state, value) {
    state.deleted = value;
  },

  /**
   * Set weather to add or edit
   *
   * @param {Object} state
   * @param {Boolean} value
   */
  setChangeToEdit(state, value) {
    state.changeToEdit = value;
  },

  /**
   * Weather appointment details is being loaded
   *
   * @param {Object} state
   * @param {Boolean} value
   */
  setLoadingAppointmentDetails(state, value) {
    state.loadingAppointmentDetails = value;
  },

  /**
   * Clear state
   *
   * @param {Object} state
   */
  setAppointmentDetailStateToEmpty(state) {
    state.loadingAppointmentDetails = false;
    state.deleted = false;
    state.idQueried = [];
    state.details = {};
    state.changeToEdit = false;
  }
};
